/**
 * Widget version injected at container startup via entrypoint.sh.
 * The placeholder is replaced with the actual version from FIINDER_WIDGET_VERSION env var.
 */
export const WIDGET_VERSION = "__FIINDER_WIDGET_VERSION_PLACEHOLDER__";

// Side effect: set window global immediately when this module is imported
// This ensures the version is available even if React fails to mount
if (typeof window !== "undefined") {
  (window as unknown as Record<string, string>).__FIINDER_WIDGET_VERSION__ =
    WIDGET_VERSION;
}
